import React, { FunctionComponent } from 'react'
import CaretDown from './caret'
import NotificationIcon from './notification'
import Router from './router'
import Diagnostics from './diagnostics'
import File from './file'
import Cancel from './cancel'
import Download from './download'
import Server from './server'
import Ring from './ring'

interface Props {
    name: string
    className?: string
}

const Icon: FunctionComponent<Props> = ({ name, className }) => {
    switch (name) {
        case 'caret-down':
            return <CaretDown className={className} />
        case 'notification':
            return <NotificationIcon className={className} />
        case 'router':
            return <Router className={className} />
        case 'diagnostics':
            return <Diagnostics className={className} />
        case 'file':
            return <File className={className} />
        case 'cancel':
            return <Cancel className={className} />
        case 'download':
            return <Download className={className} />
        case 'server':
            return <Server className={className} />
        case 'ring':
            return <Ring className={className} />
        default:
            return <></>
    }
}

export default Icon
